'use client';

import { useEffect, useState } from 'react';

import { useShowByLocationSlug } from './useFilteredSlicesItemByLocationSlug';

type UseSliceVisibilityOptions = {
  isServerVisible: boolean;
  locationSlug?: string | null;
};

/**
 * Before hydration: trust isServerVisible (no flash on F5).
 * After hydration: react to store picker via location_slug.
 */
const useSliceVisibility = ({
  isServerVisible,
  locationSlug,
}: UseSliceVisibilityOptions): boolean => {
  const { showContent } = useShowByLocationSlug(locationSlug);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted ? showContent : isServerVisible;
};

export { useSliceVisibility };
